import { createContext } from 'react';

const ShowroomDisplayContext = createContext(null);

export default ShowroomDisplayContext;
